import { render, staticRenderFns } from "./VersionBrowser.vue?vue&type=template&id=3fe15c3c&scoped=true&"
import script from "./VersionBrowser.vue?vue&type=script&lang=js&"
export * from "./VersionBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe15c3c",
  null
  
)

export default component.exports